<template></template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import store from '@/lib/store'
  import { recordingStartedNotification } from './notifications'

  const { mapActions } = createNamespacedHelpers('conference')

  export default {
    props: [
      'channel'
    ],
    data () {
      return {
        user: store.get('user')
      }
    },
    created () {
      this.channel.bind('recording.started', () => {
        this.markRecordingState('in-progress')
        this.markRecordingButtonDisabled(false)

        if (!this.user.softphoneOutboundRecordPreference) {
          recordingStartedNotification().show()
        }
      })
    },
    methods: mapActions([
      'markRecordingState',
      'markRecordingButtonDisabled'
    ])
  }
</script>



// WEBPACK FOOTER //
// recording-started.vue?627a449c